import React from "react";
import "./HowItWorks.css";

const HowItWorks = () => {
  const steps = [
    {
      icon: "📢",
      title: "Crea tu Perfil",
      description:
        "Regístrate como vendedor en MegaLoto y obtén tu enlace de referidos personalizado. ¡Es rápido y gratuito!",
    },
    {
      icon: "🔗",
      title: "Comparte tu Enlace",
      description:
        "Comparte tu enlace en redes sociales, con amigos y familiares. Cada recarga y compra suma beneficios.",
    },
    {
      icon: "💵",
      title: "Gana Recompensas",
      description:
        "Recibe comisiones por cada recarga y premio ganado por tus referidos, ¡hasta en dos niveles!",
    },
  ];

  return (
    <div className="how-it-works">
      <h2>¿Cómo Funciona?</h2>
      <p>
        Sigue estos sencillos pasos y comienza a ganar dinero mientras ayudas a
        otros a participar en los sorteos de MegaLoto.
      </p>
      <div className="steps-container">
        {steps.map((step, index) => (
          <div key={index} className="step-card">
            <div className="icon">{step.icon}</div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
